import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRightIcon, CheckCircleIcon, CalendarIcon, MessageCircleIcon } from 'lucide-react';
// Helper function to get current month name in English
const getCurrentMonthName = () => {
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  return months[new Date().getMonth()];
};
// Helper function to get available spots based on day of month
const getAvailableSpots = () => {
  const dayOfMonth = new Date().getDate();
  if (dayOfMonth <= 10) return 3;
  if (dayOfMonth <= 20) return 2;
  return 1;
};
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const currentMonth = getCurrentMonthName();
  const availableSpots = getAvailableSpots();
  return <section className="py-24 lg:py-32 bg-gradient-to-b from-[#0c0c0c] to-[#0a0a0a]" id="contact" ref={ref} data-id="element-81" data-mp="2c4oct12z9f8b">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82" data-mp="2h4ss4ns5g3wy">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="relative rounded-3xl bg-gradient-to-br from-[#0ea5e9]/20 via-[#1a1a1a] to-[#06b6d4]/20 border border-[#0ea5e9]/30 p-8 lg:p-16 overflow-hidden" data-id="element-83" data-mp="2m2ud5e94ydb2">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#0ea5e9]/10 blur-[100px] pointer-events-none" data-id="element-84" data-mp="39rdipm0swbzg" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#06b6d4]/10 blur-[100px] pointer-events-none" data-id="element-85" data-mp="3est6vmy9yym2" />

          <div className="relative text-center" data-id="element-86" data-mp="3itcyyc3zrc1c">
            {/* Urgency badge */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={isInView ? {
            opacity: 1,
            scale: 1
          } : {}} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-500/20 border border-orange-500/30 text-orange-400 text-sm font-medium mb-8" data-id="element-87" data-mp="1jp4s1kbqipkp">
              <span className="w-2 h-2 bg-orange-400 rounded-full animate-pulse" data-id="element-88" data-mp="2bezkvqyswxe4" />
              Only {availableSpots} {availableSpots === 1 ? 'spot' : 'spots'}{' '}
              left in {currentMonth}
            </motion.div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6" data-id="element-89" data-mp="h3bc66j5xr26">
              Ready to transform your sales?
            </h2>
            <p className="text-lg lg:text-xl text-gray-400 max-w-2xl mx-auto mb-8" data-id="element-90" data-mp="2x9h3l5ofjl0">
              Book your free strategy call now. We analyze your situation and
              show you how Close CRM can increase your revenue.
            </p>

            {/* Value props */}
            <div className="flex flex-wrap justify-center gap-6 mb-10" data-id="element-91" data-mp="3u9u9hod807w3">
              {['Free CRM Analysis', '30-Day Money-Back Guarantee', 'No Obligation'].map((item, index) => <div key={index} className="flex items-center gap-2 text-gray-300" data-id="element-92" data-mp="3kad83j504g5x" data-mpi={index}>
                  <CheckCircleIcon className="w-5 h-5 text-emerald-400" data-id="element-93" data-mp="3bb9li56mlimo" />
                  <span data-id="element-94" data-mp="3bdmb94imkxaa">{item}</span>
                </div>)}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-10" data-id="element-95" data-mp="19k4w7fs60u5i">
              <a href="/free-strategy-call" className="group inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#0ea5e9] text-white font-semibold rounded-xl hover:bg-[#0284c7] transition-all duration-200 shadow-lg shadow-[#0ea5e9]/30" data-id="element-96" data-mp="35njeel859lma">
                <CalendarIcon className="w-5 h-5" data-id="element-97" data-mp="2vr82hwcguxsd" />
                Book Free Call
                <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-98" data-mp="2rniasy0hw034" />
              </a>
              <a href="https://wa.me/491745444423" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#25D366]/10 text-[#25D366] font-semibold rounded-xl border border-[#25D366]/30 hover:bg-[#25D366]/20 transition-all duration-200" data-id="element-99" data-mp="2mqi4qn3naxc0">
                <MessageCircleIcon className="w-5 h-5" data-id="element-100" data-mp="23xe9ixas4cfa" />
                +49 174 5444423
              </a>
            </div>

            {/* Trust elements */}
            <p className="text-sm text-gray-500" data-id="element-101" data-mp="ehv710segcar">
              Response guaranteed within 24 hours
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}